import React, { FC } from 'react'
import CompaniesListContainer from 'containers/Companies/CompaniesList'

const CompaniesListPage: FC = () => <CompaniesListContainer />

export default CompaniesListPage
